import { render, staticRenderFns } from "./HoldCurrencyList.vue?vue&type=template&id=3498053f&scoped=true&"
import script from "./HoldCurrencyList.vue?vue&type=script&lang=js&"
export * from "./HoldCurrencyList.vue?vue&type=script&lang=js&"
import style0 from "./HoldCurrencyList.vue?vue&type=style&index=0&id=3498053f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498053f",
  null
  
)

export default component.exports